import { render } from "./BillingBillListPage.vue?vue&type=template&id=677cd644&ts=true"
import script from "./BillingBillListPage.vue?vue&type=script&lang=ts"
export * from "./BillingBillListPage.vue?vue&type=script&lang=ts"

import "./BillingBillListPage.vue?vue&type=style&index=0&id=677cd644&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__